/**
 * Identifiers for the lifecycle error events emitted during a request.
 *
 * @public
 */
export const ErrorEventEnum = {
  NETWORK: 'network',
  TIMEOUT: 'timeout',
  ABORT: 'abort',

  AUTH_REFRESH_FAILED: 'auth_refresh_failed',
  AUTH_TOKEN_FAILED: 'auth_token_failed',

  UNKNOWN: 'unknown'
} as const
